import React, { useState } from 'react';
import { updateProjectImage } from '../../services/projectServices';
import { message } from 'antd';
import { useDispatch } from "react-redux";
import FdCamEditor from '../ImageEditor/FdCamEditor';


const ImageEditorModal = ({
  imageUrl,
  originalImageUrl,
  annotationsData,
  project_id,
  image_id,
  setEditorVisible,
  setImageId,
  setSelectedImage,
  fetchProject,
}) => {
  const [isImgEditorShown, setIsImgEditorShown] = useState(true);
  const dispatch = useDispatch();

  function dataURLtoBlob(dataURL) {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  const handleImageSave = async (editedImage) => {
    try {
      const formData = new FormData();
      const blob = dataURLtoBlob(editedImage.imageBase64);
      const file = new File([blob], editedImage.fullName, { type: editedImage.mimeType });
      formData.append('image', file);
      formData.append('project_id', project_id);

      if (editedImage.cleanBase64) {
        const cleanBlob = dataURLtoBlob(editedImage.cleanBase64);
        const cleanFile = new File([cleanBlob], `clean-${editedImage.fullName}`, { type: editedImage.mimeType });
        formData.append('clean_image', cleanFile);
      }

      if (editedImage.annotations) {
        formData.append('annotations_data', JSON.stringify(editedImage.annotations));
      }

      await dispatch(updateProjectImage(project_id, image_id, formData));

      // Close editor modal and notify immediately upon success
      setIsImgEditorShown(false);
      setEditorVisible(false);
      setImageId(null);
      setSelectedImage(null);
      message.success('Image has been updated successfully!');

      // Silently refresh project data in the background
      if (typeof fetchProject === 'function') {
        fetchProject();
      }
    } catch (error) {
      message.error('Failed to save image');
      throw error;
    }
  };

  const closeImgEditor = () => {
    setIsImgEditorShown(false);
    setEditorVisible(false);
    setImageId(null);
    setSelectedImage(null);
  };

  // If annotations exist with active objects, use the clean original photo as the background so old baked pixels are not duplicated.
  // If no annotations exist (e.g. image was only rotated/cropped), use imageUrl directly to guarantee exact orientation.
  const hasAnnotations = annotationsData && (
    (Array.isArray(annotationsData) && annotationsData.length > 0) ||
    (Array.isArray(annotationsData.objects) && annotationsData.objects.length > 0)
  );
  let editorSource = (hasAnnotations && originalImageUrl && originalImageUrl !== imageUrl) ? originalImageUrl : imageUrl;
  if (editorSource && !editorSource.startsWith("blob:") && !editorSource.includes("cb=") && !editorSource.includes("not-from-cache")) {
    const sep = editorSource.includes("?") ? "&" : "?";
    editorSource = `${editorSource}${sep}cb=${Date.now()}`;
  }

  return (
    <div className="w-full h-full overflow-hidden">
      {isImgEditorShown && (
        <FdCamEditor
          source={editorSource}
          initialAnnotations={hasAnnotations ? annotationsData : null}
          fileName={`project-image-${image_id || 'edited'}.png`}
          onSave={handleImageSave}
          onClose={closeImgEditor}
        />
      )}
    </div>
  );
};

export default ImageEditorModal;
